function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M27.421 14.049a1.624 1.624 0 00-1.393-1.192l-3.737-3.736-4.209-4.209a3.417 3.417 0 00.247-.7 3.329 3.329 0 00.088-.765A3.421 3.421 0 0017.4 1.008 3.474 3.474 0 0014.947 0a3.437 3.437 0 00-.757.084 3.552 3.552 0 00-.7.237l1.145 1.145 1.145 1.145-.51 1.237-1.238.511L12.9 3.222l-1.142-1.138a3.47 3.47 0 00-.208.655 3.427 3.427 0 00.943 3.139 3.474 3.474 0 002.454 1.008 3.474 3.474 0 001.345-.268l4.23 4.23 3.705 3.705a1.594 1.594 0 00.053.338 1.626 1.626 0 003.141-.842zm-.693.656a.909.909 0 11-.236-.877.909.909 0 01.236.877z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M29.452 24.2h-.025V17h-.989v2.2H8.284L4.425 9.65.909 9.624H.9a.9.9 0 00-.007 1.8l2.31.017L8.363 24.2h-.095l.972 2.3h20.237zm-19.21-.165l-1.405-3.478h19.6V24.2H10.273a.857.857 0 00-.031-.17zM25.188 26.939a1.685 1.685 0 101.619 1.684 1.653 1.653 0 00-1.619-1.684z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-1",
  cx: 11.504,
  cy: 28.623,
  rx: 1.619,
  ry: 1.684
})));

var SvgWagonmin = function SvgWagonmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29.477 30.307",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWagonmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Wagon.min.f624cec3.svg";
export { ForwardRef as ReactComponent };